// Using same logic as https://app.hubspot.com/workflows/6365936/platform/flow/464745589/edit/actions/1/custom-code

const zipCodes = [
    {
        state: 'AK',
        zipMin: 99501,
        zipMax: 99950,
    },
    {
        state: 'AL',
        zipMin: 35004,
        zipMax: 36925,
    },
    {
        state: 'AR',
        zipMin: 71601,
        zipMax: 72959,
    },
    {
        state: 'AR',
        zipMin: 75502,
        zipMax: 75502,
    },
    {
        state: 'AZ',
        zipMin: 85001,
        zipMax: 86556,
    },
    {
        state: 'CA',
        zipMin: 90001,
        zipMax: 96162,
    },
    {
        state: 'CO',
        zipMin: 80001,
        zipMax: 81658,
    },
    {
        state: 'CT',
        zipMin: 6001,
        zipMax: 6389,
    },
    {
        state: 'CT',
        zipMin: 6401,
        zipMax: 6928,
    },
    {
        state: 'DC',
        zipMin: 20001,
        zipMax: 20039,
    },
    {
        state: 'DC',
        zipMin: 20042,
        zipMax: 20599,
    },
    {
        state: 'DC',
        zipMin: 20799,
        zipMax: 20799,
    },
    {
        state: 'DE',
        zipMin: 19701,
        zipMax: 19980,
    },
    {
        state: 'FL',
        zipMin: 32004,
        zipMax: 34997,
    },
    {
        state: 'GA',
        zipMin: 30001,
        zipMax: 31999,
    },
    {
        state: 'GA',
        zipMin: 39901,
        zipMax: 39901,
    },
    {
        state: 'HI',
        zipMin: 96701,
        zipMax: 96898,
    },
    {
        state: 'IA',
        zipMin: 50001,
        zipMax: 52809,
    },
    {
        state: 'IA',
        zipMin: 68119,
        zipMax: 68120,
    },
    {
        state: 'ID',
        zipMin: 83201,
        zipMax: 83876,
    },
    {
        state: 'IL',
        zipMin: 60001,
        zipMax: 62999,
    },
    {
        state: 'IN',
        zipMin: 46001,
        zipMax: 47997,
    },
    {
        state: 'KS',
        zipMin: 66002,
        zipMax: 67954,
    },
    {
        state: 'KY',
        zipMin: 40003,
        zipMax: 42788,
    },
    {
        state: 'LA',
        zipMin: 70001,
        zipMax: 71232,
    },
    {
        state: 'LA',
        zipMin: 71234,
        zipMax: 71497,
    },
    {
        state: 'MA',
        zipMin: 1001,
        zipMax: 2791,
    },
    {
        state: 'MA',
        zipMin: 5501,
        zipMax: 5544,
    },
    {
        state: 'MD',
        zipMin: 20331,
        zipMax: 20331,
    },
    {
        state: 'MD',
        zipMin: 20335,
        zipMax: 20797,
    },
    {
        state: 'MD',
        zipMin: 20812,
        zipMax: 21930,
    },
    {
        state: 'ME',
        zipMin: 3901,
        zipMax: 4992,
    },
    {
        state: 'MI',
        zipMin: 48001,
        zipMax: 49971,
    },
    {
        state: 'MN',
        zipMin: 55001,
        zipMax: 56763,
    },
    {
        state: 'MO',
        zipMin: 63001,
        zipMax: 65899,
    },
    {
        state: 'MS',
        zipMin: 38601,
        zipMax: 39776,
    },
    {
        state: 'MS',
        zipMin: 71233,
        zipMax: 71233,
    },
    {
        state: 'MT',
        zipMin: 59001,
        zipMax: 59937,
    },
    {
        state: 'NC',
        zipMin: 27006,
        zipMax: 28909,
    },
    {
        state: 'ND',
        zipMin: 58001,
        zipMax: 58856,
    },
    {
        state: 'NE',
        zipMin: 68001,
        zipMax: 68118,
    },
    {
        state: 'NE',
        zipMin: 68122,
        zipMax: 69367,
    },
    {
        state: 'NH',
        zipMin: 3031,
        zipMax: 3897,
    },
    {
        state: 'NJ',
        zipMin: 7001,
        zipMax: 8989,
    },
    {
        state: 'NM',
        zipMin: 87001,
        zipMax: 88441,
    },
    {
        state: 'NV',
        zipMin: 88901,
        zipMax: 89883,
    },
    {
        state: 'NY',
        zipMin: 6390,
        zipMax: 6390,
    },
    {
        state: 'NY',
        zipMin: 10001,
        zipMax: 14975,
    },
    {
        state: 'OH',
        zipMin: 43001,
        zipMax: 45999,
    },
    {
        state: 'OK',
        zipMin: 73001,
        zipMax: 73199,
    },
    {
        state: 'OK',
        zipMin: 73401,
        zipMax: 74966,
    },
    {
        state: 'OR',
        zipMin: 97001,
        zipMax: 97920,
    },
    {
        state: 'PA',
        zipMin: 15001,
        zipMax: 19640,
    },
    {
        state: 'PR',
        zipMin: 0,
        zipMax: 0,
    },
    {
        state: 'RI',
        zipMin: 2801,
        zipMax: 2940,
    },
    {
        state: 'SC',
        zipMin: 29001,
        zipMax: 29948,
    },
    {
        state: 'SD',
        zipMin: 57001,
        zipMax: 57799,
    },
    {
        state: 'TN',
        zipMin: 37010,
        zipMax: 38589,
    },
    {
        state: 'TX',
        zipMin: 73301,
        zipMax: 73301,
    },
    {
        state: 'TX',
        zipMin: 75001,
        zipMax: 75501,
    },
    {
        state: 'TX',
        zipMin: 75503,
        zipMax: 79999,
    },
    {
        state: 'TX',
        zipMin: 88510,
        zipMax: 88589,
    },
    {
        state: 'UT',
        zipMin: 84001,
        zipMax: 84784,
    },
    {
        state: 'VA',
        zipMin: 20040,
        zipMax: 20041,
    },
    {
        state: 'VA',
        zipMin: 20040,
        zipMax: 20167,
    },
    {
        state: 'VA',
        zipMin: 20042,
        zipMax: 20042,
    },
    {
        state: 'VA',
        zipMin: 22001,
        zipMax: 24658,
    },
    {
        state: 'VT',
        zipMin: 5001,
        zipMax: 5495,
    },
    {
        state: 'VT',
        zipMin: 5601,
        zipMax: 5907,
    },
    {
        state: 'WA',
        zipMin: 98001,
        zipMax: 99403,
    },
    {
        state: 'WI',
        zipMin: 53001,
        zipMax: 54990,
    },
    {
        state: 'WV',
        zipMin: 24701,
        zipMax: 26886,
    },
    {
        state: 'WY',
        zipMin: 82001,
        zipMax: 83128,
    },
];

export function getStatesFromZip(zipcode: number) {
    let state: string;
    let state2: string | undefined;

    if (zipcode) {
        if (zipcode == 2861) {
            state = 'MA';
            state2 = 'RI';
        } else if (zipcode == 42223) {
            state = 'KY';
            state2 = 'TN';
        } else if (zipcode == 59221) {
            state = 'MT';
            state2 = 'ND';
        } else if (zipcode == 63673) {
            state = 'IL';
            state2 = 'MO';
        } else if (zipcode == 71749) {
            state = 'AR';
            state2 = 'LA';
        } else if (zipcode == 73949) {
            state = 'OK';
            state2 = 'TX';
        } else if (zipcode == 81137) {
            state = 'CO';
            state2 = 'NM';
        } else if (zipcode == 84536) {
            state = 'AZ';
            state2 = 'UT';
        } else if (zipcode == 86044) {
            state = 'AZ';
            state2 = 'UT';
        } else if (zipcode == 86515) {
            state = 'AZ';
            state2 = 'NM';
        } else if (zipcode == 88063) {
            state = 'NM';
            state2 = 'TX';
        } else if (zipcode == 89439) {
            state = 'CA';
            state2 = 'NV';
        } else if (zipcode == 97635) {
            state = 'CA';
            state2 = 'OR';
        } else {
            for (const zipState of zipCodes) {
                if (zipcode >= zipState.zipMin && zipcode <= zipState.zipMax) {
                    state = zipState.state;
                    break;
                }
            }
        }
    }

    return {state, state2};
}
